<template>
  <UCard v-if="isSignedIn">
    <UButton color="primary" class="rounded-none" @click="signOut">
      Logout from {{ signedInAs }}
    </UButton>
  </UCard>

  <UCard v-else>
    <template #header>
      <UButton color="primary" class="rounded-none" @click="signIn">
        Login as admin
      </UButton>
    </template>
    <div class="-m-3 flex flex-wrap">
      <div class="min-w-0 flex-1 p-3">
        <UFormField label="username" name="username">
          <UInput v-model="username" class="w-full" />
        </UFormField>
      </div>
      <div class="min-w-0 flex-1 p-3">
        <UFormField label="password" name="password">
          <UInput v-model="password" type="password" class="w-full" />
        </UFormField>
      </div>
    </div>
  </UCard>
</template>

<script setup lang="ts">
const auth = useAuth();
const username = ref<string>();
const password = ref<string>();

const signIn = async () => {
  if (typeof username.value !== 'string') throw Error('Invalid username');
  if (typeof password.value !== 'string') throw Error('Invalid password');
  await auth.signIn('credentials', {
    username: username.value,
    password: password.value,
  });
};

const signOut = async () => {
  await auth.signOut();
};

const isSignedIn = computed(() => auth.status.value === 'authenticated');
const signedInAs = computed(
  () => auth.data.value?.user?.email ?? 'unavailable'
);
</script>
